import { v4 as uuidv4 } from 'uuid';
import { ENVIROMENT } from '../assets/constants/enviroments';
import { useAppConfig } from '../hooks/useAppConfig';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
export const formatDate = (date) => {
    if (typeof date === 'string')
        return date.split('T')[0];
    return date.toISOString().split('T')[0];
};
export const copyTextClipboard = (text) => {
    let tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
};
export const openPlayStore = () => window.open('https://play.google.com/store/apps/details?id=com.mibanco.bancamovil', '_blank', 'noopener');
export const openAppStore = () => window.open('https://apps.apple.com/pe/app/mibanco/id1437814246', '_blank', 'noopener');
export const openAppGallery = () => window.open('https://appgallery.huawei.com/app/C102237875', '_blank', 'noopener');
export const detectarSO = () => {
    let platform = navigator.platform.toLowerCase();
    let userAgent = navigator.userAgent.toLowerCase();
    console.log("platform", platform);
    if (platform.includes('linux') || platform.includes('android')) {
        if (userAgent.includes('android')) {
            return 'android';
        }
        else {
            return 'harmony';
        }
    }
    else if (platform.includes('iphone') || platform.includes('ipad') || platform.includes('ipod') || platform.includes('macintel')) {
        return 'ios';
    }
    else {
        return 'harmony';
    }
};
export const capitalizeText = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
export const capitalizeFirstLetter = (str) => {
    if (str.length === 0)
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
export const toTitleCase = (str) => {
    return str.toLowerCase().split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
};
export const hashData = (text) => {
    const base64Hash = btoa(text);
    return base64Hash;
};
export const generateUuid = () => uuidv4();
export const getTimestamp = () => {
    const currentDatetime = dayjs().tz("America/Lima");
    return currentDatetime.format("YYYYMMDDHHmmssSSS");
};
export const isOlder = (birthdateStr) => {
    const birthDate = new Date(birthdateStr);
    const today = new Date();
    const date18ago = new Date();
    date18ago.setFullYear(today.getFullYear() - 18);
    return birthDate <= date18ago;
};
export const validateDate = (dateStr) => {
    const date = new Date(dateStr);
    const today = new Date();
    return date <= today;
};
export const useIsAttentionSchedule = () => {
    const { ATTENTION_HOUR_START, ATTENTION_HOUR_END } = useAppConfig();
    const is24x7 = useIs24x7();
    if (isDeveloperMode()) {
        return true;
    }
    if (is24x7)
        return true;
    const now = dayjs().tz("America/Lima");
    const attentionHourEnd = ATTENTION_HOUR_END || process.env.ATTENTION_HOUR_END || "21:00";
    const attentionHourStart = ATTENTION_HOUR_START || process.env.ATTENTION_HOUR_START || "05:00";
    const [endHour, endMinute] = attentionHourEnd.split(":").map(Number);
    const [startHour, startMinute] = attentionHourStart.split(":").map(Number);
    const attentionStart = dayjs().tz("America/Lima").hour(startHour).minute(startMinute);
    const attentionEnd = dayjs().tz("America/Lima").hour(endHour).minute(endMinute);
    if (now.isBefore(attentionStart) || now.isSame(attentionEnd) || now.isAfter(attentionEnd)) {
        return false;
    }
    return true;
};
export const useIsAttention24x7 = () => {
    const { ATTENTION_HOUR_START, ATTENTION_HOUR_END } = useAppConfig();
    if (isDeveloperMode()) {
        return true;
    }
    const now = dayjs().tz("America/Lima");
    const attentionHourEnd = ATTENTION_HOUR_END || process.env.ATTENTION_HOUR_END || "21:00";
    const attentionHourStart = ATTENTION_HOUR_START || process.env.ATTENTION_HOUR_START || "05:00";
    const [endHour, endMinute] = attentionHourEnd.split(":").map(Number);
    const [startHour, startMinute] = attentionHourStart.split(":").map(Number);
    const attentionStart = dayjs().tz("America/Lima").hour(startHour).minute(startMinute);
    const attentionEnd = dayjs().tz("America/Lima").hour(endHour).minute(endMinute);
    if (now.isBefore(attentionStart) || now.isSame(attentionEnd) || now.isAfter(attentionEnd)) {
        return false;
    }
    return true;
};
export function obtenerPrimerNombre(valor) {
    if (typeof valor !== 'string')
        return '';
    return valor
        .trim()
        .replace(/\s+/g, ' ')
        .split(' ')[0]
        .split('-')
        .map(parte => parte.charAt(0).toUpperCase() +
        parte.slice(1).toLowerCase())
        .join('-');
}
export const useIs24x7 = () => {
    return true;
};
export const useIsMaintenanceMode = () => {
    const { MAINTENANCE_MODE, MAINTENANCE_HOUR_END, MAINTENANCE_HOUR_START } = useAppConfig();
    const maintenance_mode = MAINTENANCE_MODE || process.env.MAINTENANCE_MODE || "0";
    const maintenanceMode = !!MAINTENANCE_MODE ? maintenance_mode : "0";
    if (maintenanceMode === "0") {
        return maintenanceMode;
    }
    const now = dayjs().tz("America/Lima");
    const maintenanceHourEnd = MAINTENANCE_HOUR_END || process.env.MAINTENANCE_HOUR_END || "21:00";
    const maintenancHourStart = MAINTENANCE_HOUR_START || process.env.MAINTENANCE_HOUR_START || "05:00";
    const [endHour, endMinute] = maintenanceHourEnd.split(":").map(Number);
    const [startHour, startMinute] = maintenancHourStart.split(":").map(Number);
    const maintenanceStart = dayjs().tz("America/Lima").hour(startHour).minute(startMinute);
    const maintenanceEnd = dayjs().tz("America/Lima").hour(endHour).minute(endMinute);
    if (now.isBefore(maintenanceStart) || now.isSame(maintenanceEnd) || now.isAfter(maintenanceEnd)) {
        return "0";
    }
    else {
        return "1";
    }
};
export const convertTo12HourFormat = (time24) => {
    if (!/^\d{2}:\d{2}$/.test(time24)) {
        return "Formato inválido";
    }
    const [hourStr, minuteStr] = time24.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        return "Hora inválida";
    }
    const period = hour < 12 ? "a.m." : "p.m.";
    let hour12 = hour % 12;
    hour12 = hour12 === 0 ? 12 : hour12;
    return `${hour12}:${minuteStr} ${period}`;
};
export const ofuscateDocumentNumber = (documentNumber) => {
    if (!documentNumber)
        return "";
    if (documentNumber.length < 2)
        return documentNumber;
    const totalLength = documentNumber.length;
    const firstNumberOfCharacters = 2;
    const lastNumberOfCharacters = 2;
    const firstCharacters = documentNumber.slice(0, firstNumberOfCharacters);
    if (documentNumber.length <= (firstNumberOfCharacters + lastNumberOfCharacters))
        return `${firstCharacters}${documentNumber.slice(firstNumberOfCharacters)}`;
    const lastCharacters = documentNumber.slice(totalLength - lastNumberOfCharacters);
    const betweenNumberOfCharacters = totalLength - lastNumberOfCharacters - firstNumberOfCharacters;
    return `${firstCharacters}${"*".repeat(betweenNumberOfCharacters)}${lastCharacters}`;
};
export const createBlobUrl = (blob) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    return url;
};
export const isFullAhorroAccount = (accountType) => {
    if ((accountType === "FullAhorroSoles") || (accountType === "FullAhorroDólares")) {
        return true;
    }
    else {
        return false;
    }
};
export const fetchBlob = (url) => {
    return fetch(url)
        .then(response => response.blob());
};
export const useObtainAttentionSchedule = () => {
    const { ATTENTION_HOUR_START, ATTENTION_HOUR_END } = useAppConfig();
    const startHour = convertTo12HourFormat(ATTENTION_HOUR_START || process.env.ATTENTION_HOUR_START || "05:00");
    const endHour = convertTo12HourFormat(ATTENTION_HOUR_END || process.env.ATTENTION_HOUR_END || "21:00");
    return [startHour, endHour];
};
export const isDeveloperMode = () => {
    if (process.env.ENVIRONMENT === ENVIROMENT.DEBUG) {
        return true;
    }
};
export const getFilteredProvinces = (departments, livingDepartment) => {
    return departments
        .filter(item => item.departamento === livingDepartment)
        .map(item => ({
        label: capitalizeFirstLetter(item.provincia),
        value: item.provincia
    }))
        .reduce((acc, curr) => {
        if (!acc.find(item => item.value === curr.value)) {
            acc.push(curr);
        }
        return acc;
    }, []);
};
export const getFilteredDistricts = (provinces, livingProvince) => {
    return provinces
        .filter(item => item.provincia === livingProvince)
        .map(item => ({
        label: capitalizeFirstLetter(item.distrito),
        value: item.distrito
    }))
        .reduce((acc, curr) => {
        if (!acc.find(item => item.value === curr.value)) {
            acc.push(curr);
        }
        return acc;
    }, []);
};
export const obtenerCodigoProvinciaDistrito = async (departamento, provincia, distrito, listDptoProvDistrict) => {
    const resultado = listDptoProvDistrict.find(item => item.departamento.toLocaleUpperCase() == departamento.toLocaleUpperCase() && item.provincia.toLocaleUpperCase() == provincia.toLocaleUpperCase() && item.distrito.toLocaleUpperCase() == distrito.toLocaleUpperCase());
    return resultado;
};
export const preloadImages = (images) => {
    images.forEach((image) => {
        const img = new Image();
        img.src = image;
    });
};
export const isAhorroNegocios = (accountType) => {
    if ((accountType === "AhorroNegociosSoles") || (accountType === "AhorroNegociosDólares")) {
        return true;
    }
    else {
        return false;
    }
};
export const isSuperTasaAFP = (accountType) => {
    if ((accountType === "SuperTasaAFPSoles")) {
        return true;
    }
    else {
        return false;
    }
};
export const obtenerCodigoProvincia = async (departamento, provincia, listDptoProv) => {
    const resultado = listDptoProv.find(item => item.departamento.toLocaleUpperCase() == departamento.toLocaleUpperCase() && item.provincia.toLocaleUpperCase() == provincia.toLocaleUpperCase());
    return resultado;
};
export const compareVersions = (v1 = '', v2 = '') => {
    if (!v1 || !v2)
        return false;
    const a = v1.split('.').map(Number);
    const b = v2.split('.').map(Number);
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const numA = a[i] || 0;
        const numB = b[i] || 0;
        if (numA > numB)
            return true;
        if (numA < numB)
            return false;
    }
    return false;
};
export const accountIdFullAhorroSoles = process.env.ENVIRONMENT === "PROD" ? "2002" : "2002";
